import { ReactNode, useState } from 'react'
import { Button, Divider, Drawer, Input } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFilter } from '@fortawesome/pro-solid-svg-icons'
import MultiSelect from '../../common/FormControls/MultiSelect'
import { InvoiceByJobFilters as Filters } from './useInvoiceByJobFilters'

import DateRangeFilter from './DateRangeFilter'
import AdditionalFilterFields from './AdditionalFilterFields'

type InvoiceByJobFiltersProps = {
  filters: Filters
  endAddition?: ReactNode
  hideDateRange?: boolean
  hideVisitStatus?: boolean
  showVisitReviewStatus?: boolean
  dateHelp?: string
}

const FilterControls = ({ filters, endAddition, hideDateRange, hideVisitStatus, showVisitReviewStatus, dateHelp }: InvoiceByJobFiltersProps) => {
  const [drawerOpen, setDrawerOpen] = useState(false)
  const { invoicedStatus } = filters.state

  return <>
    <div style={{ display: 'flex', flex: 1, flexDirection: 'row', gap: 16, alignItems: 'center', flexWrap: 'wrap' }}>
      <div style={{ flex: 1, minWidth: 200 }}>
        <Input.Search
          placeholder="Search by customer or job name"
          allowClear
          value={filters.state.search}
          onChange={(e) => filters.setSearch(e.target.value)}
        />
      </div>
      {!hideVisitStatus && <>
        <Divider type="vertical" />
        <div>
          <MultiSelect
            options={invoicedStatus.values.map(x => ({ label: x.name, value: x.value }))}
            selectedValues={invoicedStatus.values.filter(x => x.selected).map(x => x.value)}
            onChange={selectedValues => filters.setCategory('invoicedStatus', selectedValues)}
            placeholder="Select visit statuses"
            allSelectedText="All Visit Statuses"
            maxTagCount={4}
            style={{ width: 200 }}
          />
        </div>
      </>}
      {!hideDateRange && <div>
        <DateRangeFilter filters={filters} dateHelp={dateHelp} />
      </div>}
      <div>
        <Button
          icon={<FontAwesomeIcon icon={faFilter} />}
          onClick={() => setDrawerOpen(true)}
        >
          Additional Filters
        </Button>
      </div>
      {endAddition && <>
        <Divider type="vertical" />
        <div style={{ marginLeft: 'auto' }}>{endAddition}</div>
      </>}
    </div>

    <Drawer
      title="Additional Filters"
      open={drawerOpen}
      onClose={() => setDrawerOpen(false)}
      placement="right"
      width={320}
    >
      <AdditionalFilterFields filters={filters} showVisitReviewStatus={showVisitReviewStatus} />
    </Drawer>
  </>
}

export default FilterControls
